import { configureStore } from '@reduxjs/toolkit';
import userTableReducer from './userTableSlice';
import userGenerationReducer from './userGenerationSlice';
import authReducer from './authSlice';
import errorReducer from './errorSlice';
import preferencesReducer from './preferencesSlice';
import { thunk } from 'redux-thunk';

export const store = configureStore({
  reducer: {
    userTable: userTableReducer,
    userGeneration: userGenerationReducer,
    auth: authReducer,
    error: errorReducer,
    preferences: preferencesReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/REGISTER',
          'persist/FLUSH',
          'persist/PAUSE',
          'persist/PURGE'
        ],
        ignoredPaths: [
          'auth.user',
          'persist._persist' // Ignore persist metadata
        ], // Allow user objects in auth slice
      },
    }).concat(thunk),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
